import './styles/contact-form.css'
import Input from './UI/Input'
import PurpleBtn from './UI/PurpleBtn'

export default function ContactForm() {
  return (
    <form className='contant-form'>
      <div className='contant-form__inputs'>
        <Input placeholder='Name*'/>
        <Input placeholder='Email*'/>
        <Input placeholder='Company'/>
        <Input placeholder='Phone'/>
      </div>
      <div className='contant-form__text'>
        <textarea 
        placeholder='Comment*'
        className='contant-form__textarea' 
        cols="30" rows="10"></textarea>
      </div>
      <div className='contant-form__btn'>
        <PurpleBtn width={'146'} text='submit'/>
      </div>
    </form>
  )
}
